export const formatOptionLabel = (
  name: string,
  {
    isSoldOut,
    extraDonationAmount,
  }: { isSoldOut?: boolean; extraDonationAmount?: number },
): string => {
  if (isSoldOut) return `${name} (품절)`;
  if (extraDonationAmount) {
    return `${name} (+${extraDonationAmount.toLocaleString()}원)`;
  }

  return name;
};
